import React from "react"
import ReactDOM from "react-dom"
import { H4 } from "@infotech/uikit-text"
import { Flex } from "src/components/Grid"
import TrashIcon from "src/icons/trashMultiselect.svg"
import CrossIcon from "src/icons/fatCross.svg"
import debounce from "lodash/debounce"
import classnames from "classnames"
import UnlockedIcon from "src/icons/unlocked.svg"
import LockedIcon from "src/icons/locked.svg"
import withModalSetup from "../hocs/withModalSetup"
import styles from "./styles.css"

class ModalConfirm extends React.Component {
  state = {
    shouldShake: false,
  }

  handleOverlayClick = debounce(
    e => {
      e.stopPropagation()
      this.setState({ shouldShake: true }, () => {
        setTimeout(() => this.setState({ shouldShake: false }), 1000)
      })
    },
    600,
    {
      leading: true,
      trailing: false,
    },
  )

  render() {
    const { shouldShake } = this.state
    const {
      title,
      children,
      isOpen,
      isRemove,
      isClose,
      isLock,
      isUnlock,
      isModalMounted,
      containerDomNode,
      buttonReactNodes,
    } = this.props
    if (!isOpen) {
      return null
    }

    return ReactDOM.createPortal(
      <div
        className={classnames(styles[`modal-overlay`])}
        onClick={this.handleOverlayClick}
      >
        <div
          className={classnames(styles[`modal-wrapper`], {
            [styles.shake]: shouldShake,
          })}
          onClick={e => e.stopPropagation()}
        >
          {isRemove && (
            <div className={styles[`trash-icon-wrapper`]}>
              <TrashIcon size="large" color="#f00" />
            </div>
          )}
          {isClose && (
            <div className={styles[`trash-icon-wrapper`]}>
              <CrossIcon size="large" color="#f00" />
            </div>
          )}
          {isLock && (
            <div className={styles[`trash-icon-wrapper`]}>
              <LockedIcon size="large" color="#000" />
            </div>
          )}
          {isUnlock && (
            <div className={styles[`trash-icon-wrapper`]}>
              <UnlockedIcon size="large" color="#aaa" />
            </div>
          )}
          <div>
            <Flex className={styles[`modal-title-wrapper`]}>
              <H4 className={styles[`modal-title`]}>{title}</H4>
            </Flex>
            <Flex column className={styles[`modal-main-wrapper`]}>
              <Flex column>{isModalMounted ? children : null}</Flex>
            </Flex>
            <Flex className={styles[`modal-footer-wrapper`]}>
              {buttonReactNodes}
            </Flex>
          </div>
        </div>
      </div>,
      containerDomNode,
    )
  }
}

export default withModalSetup(ModalConfirm)
